/**
 * 云教材使用统计api v2（学期化）
 * 云教材使用统计 v2：学期化入参 + 周/月双周期输出。 与 v1（api.textbook_cx_jw_stat）的核心口径差异： 1. semesters 多选必填（至少一个），替代日期区间参数——学期过滤采用\"领取者集合\"口径（多选取并集）：    发放数 = 所选学期归属的兑换码数（fm_redeem_code.semester IN 所选学期，已按发放日期计算）；    使用数据 = 领取了所选学期教材的学生对该教材的全部学习数据（不限学习发生时间，累计口径）。 2. 周期输出的 label：月 = YYYY-MM；周 = 该周周一日期（YYYY-MM-DD，ISO 周一为首日）。    periodType 仅 period_usage_stat 接口使用，MONTH 为默认。 3. viewTime 保留 v1 的\"一键多码乘码数\"加权语义（SUM(时长×该学生该书码数)）。 4. \"使用\"的判定统一为：存在学习行为上报记录（fm_user_drill_history 有行）即算，    不要求时长大于 0——usageQuantity（按学生去重）与 usedWeekCount（按自然周去重）同口径。 
 *
 * OpenAPI spec version: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import TextbookStatV2PeriodVo from '../../statistics/model/TextbookStatV2PeriodVo';
import TextbookStatV2QueryForm from '../../statistics/model/TextbookStatV2QueryForm';
import TextbookStatV2SemesterDictVo from '../../statistics/model/TextbookStatV2SemesterDictVo';
import TextbookStatV2StudentVo from '../../statistics/model/TextbookStatV2StudentVo';
import TextbookStatV2Vo from '../../statistics/model/TextbookStatV2Vo';
  /**
   * TextbookStatV2 service.
   * @module statistics/api/TextbookStatV2Api
   * @version 2.0.0
   */

  /**
   * Constructs a new TextbookStatV2Api. 
   * @alias module:statistics/api/TextbookStatV2Api
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;



    /**
     * 按院校/分院/专业分组统计发放使用情况（学期口径）
     * @param {module:statistics/model/TextbookStatV2QueryForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:statistics/model/TextbookStatV2Vo>}
     */
this.getStatV2GroupByCompanyDeptMajor = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling getStatV2GroupByCompanyDeptMajor";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = [TextbookStatV2Vo];
      return this.apiClient.callApi(
        '/api/textbook/stat_v2/group_by_company_dept_major', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 按学生分组统计发放使用情况（学期口径，始终统计学生）
     * @param {module:statistics/model/TextbookStatV2QueryForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:statistics/model/TextbookStatV2StudentVo>}
     */
this.getStatV2GroupByStudent = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling getStatV2GroupByStudent";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = [TextbookStatV2StudentVo];
      return this.apiClient.callApi(
        '/api/textbook/stat_v2/group_by_student', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 按教材分组统计发放使用情况（学期口径）
     * @param {module:statistics/model/TextbookStatV2QueryForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:statistics/model/TextbookStatV2Vo>}
     */
this.getStatV2GroupByTextbook = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling getStatV2GroupByTextbook";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = [TextbookStatV2Vo];
      return this.apiClient.callApi(
        '/api/textbook/stat_v2/group_by_textbook', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 学生使用情况周期统计（月/周，始终统计学生；累计口径）
     * @param {module:statistics/model/TextbookStatV2QueryForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:statistics/model/TextbookStatV2PeriodVo>}
     */
this.getStatV2PeriodUsageStatistics = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling getStatV2PeriodUsageStatistics";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = [TextbookStatV2PeriodVo];
      return this.apiClient.callApi(
        '/api/textbook/stat_v2/period_usage_stat', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 学期数据字典（学期下拉专用）
     * 返回有教材库存数据的学期枚举（来源 fm_textbook_clazz_semester 去重）， 按学期字符串倒序（最新在前）；附各公司维度是否可发放的汇总标记： anyDistributable&#x3D;任一公司可发放（distributableCompanyCount&gt;0）。 供 stat_v2 各接口的 semesters 入参多选；无库存数据的学期不返回。 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:statistics/model/TextbookStatV2SemesterDictVo>}
     */
this.getStatV2SemesterDict = function() {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = [TextbookStatV2SemesterDictVo];
      return this.apiClient.callApi(
        '/api/textbook/stat_v2/semester_dict', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }
  };

  export default exports;
